import task from '@/api/project-mgt/task-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return task.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return task.store(data)
  },
  update(context, { id, data }) {
    return task.update(id, data)
  },
  updateColumnValue(context, { id, data }) {
    return task.updateColumnValue(id, data)
  },
  destroy(context, id) {
    return task.destroy(id)
  },
  find(context, id) {
    return task.find(id)
  },
  preview(context, id) {
    return task.preview(id)
  },
  addAttachments(context, { id, data, config }) {
    return task.addAttachments(id, data, config)
  },
  removeAttachments(context, { id, fileName }) {
    return task.removeAttachments(id, fileName)
  },
  formViewModel(context, attrubutes = {}) {
    return task.formViewModel({ params: attrubutes })
  },
  history(context, attrubutes = {}) {
    return task.history({ params: attrubutes })
  },
  report(context, { id, data }) {
    return task.report(id, data)
  },
  downloadTemplate(context, data) {
    return task.downloadTemplate(data)
  },
  importTask(context, data) {
    return task.importTask(data)
  }
}
